import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class TimezoneService {

///////////////////////////////////////////////////////
  public setCreated_date(zone, createdDate): void {
    if (zone == "null" || this.isIEBrowser()) {
      localStorage.setItem('zoneCreatedDate', localStorage.getItem('createdDate'));
    }
    else {
      var zoneDate = new Date(createdDate).toLocaleString('en-US', { timeZone: zone });
      localStorage.setItem('zoneCreatedDate',moment(zoneDate). format('YYYY-MM-DD HH:mm:ss'));
    }
  }

  public getCreated_date(): string {
    return localStorage.getItem('zoneCreatedDate');
  }

/////////////////////////////////////////////////////

  public setModified_date(zone, modifiedDate): void {
    if (zone == "null" || this.isIEBrowser()) {
      localStorage.setItem('zoneModifiedDate', localStorage.getItem('ModifieddDate'));
    }
    else {
      var zoneDate = new Date(modifiedDate).toLocaleString('en-US', { timeZone: zone });
      localStorage.setItem('zoneModifiedDate',moment(zoneDate). format('YYYY-MM-DD HH:mm:ss'));
    }
  }

  public getModified_date(): string {
    return localStorage.getItem('zoneModifiedDate');
  }
////////////////////////////////////////////////


  public setOpco(Opco): void {
    localStorage.setItem('opco', Opco);
  }
  public getopco(): string {
    return localStorage.getItem('opco');
  }

/////////////////////////////////////////////

  public setZone(zone): void {
    localStorage.setItem('setZone', zone);
  }
  public getZone(): string {
    return localStorage.getItem('setZone');
  }

  public isIEBrowser(): boolean {
    const ua = window.navigator.userAgent;
    return (ua.indexOf('Trident/') > -1 || ua.indexOf("MSIE") > -1);
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/timezone.service.ts